module.exports = __webpack_public_path__ + "img/icon_record.e74e584e.svg";